import React, { useRef, useState } from 'react'

import './styles.scss'
import { renderMenuTooltip } from '../utils'
import { getStaticImage } from 'utils/statics'

const MenuTooltip = ({ options = [], toggleTooltip }) => {
  const menuTooltipRef = useRef(null)
  const [openOptionsIndex, setOpenOptionsIndex] = useState({})

  const handleOnClick = (option) => {
    option.closeMenu && toggleTooltip()
    typeof option.onClick === 'function' && option.onClick()
  }

  return (
    <div ref={menuTooltipRef} className='menu-tooltip'>
      {options.map((section, sectionIndex) => !section.every(it => it.isHidden) && (
        <ul key={sectionIndex} className='menu-tooltip__list'>
          {section.map((option, optionIndex) => !option.isHidden && (
            <li
              key={optionIndex}
              className='menu-tooltip__item'
              onClick={() => handleOnClick(option)}
              onMouseOver={() => setOpenOptionsIndex(option.options?.length ? { [sectionIndex]: optionIndex } : {})}
            >
              {option.iconName ? (
                <figure className='menu-tooltip__icon'>
                  <img src={getStaticImage(`/icons/orange-brand/${option.iconName}.svg`)} alt={option.label} />
                </figure>
              ) : null}
              <p
                title={option.label}
                className={`
                  menu-tooltip__text
                  ${!option.onClick ? 'menu-tooltip__text--label' : '' }
                  text-ellipsis
                `}
              >
                {option.label}
              </p>
              {option.selected ? (
                <p
                  title={option.selected.label}
                  className='menu-tooltip__text menu-tooltip__text--selected text-ellipsis'
                  style={{ width: !option.options?.length ? 'fit-content' : null }}
                >
                  {option.selected.label}
                </p>
              ) : null}
              {option.options?.length ? (
                <>
                  <figure className='menu-tooltip__icon menu-tooltip__icon--arrow'>
                    <img src={getStaticImage('/icons/orange-brand/icon-arrow-down-grey.svg')} alt='Options' />
                  </figure>
                  {optionIndex === openOptionsIndex[sectionIndex] ? (
                    <div
                      className='menu-tooltip__tooltip-container'
                      style={{ left: `calc(${menuTooltipRef?.current?.clientWidth || 0}px - 7px)` }}
                    >
                      {renderMenuTooltip(option.options)}
                    </div>
                  ) : null}
                </>
              ) : null}
            </li>
          ))}
        </ul>
      ))}
    </div>
  )
}

export default MenuTooltip
